angular.module('homebot.directives')

.directive('modal', ['HelperService', '$rootScope', '$state', function(helpers, $rootScope, $state){
  return {
    restrict: 'C',
    link: function($scope, el, attrs){
      let isInitialLoad = true;
      let bodyEl = window.document.body;
      let backdrop = $('<div class="modal-backdrop"></div>');
      el.after(backdrop);

      function open(){
        el.addClass('visible');
        backdrop.addClass('visible');
        _.defer(function(){ bodyEl.classList.add('modal-open'); }); // defer to animate smoothly
      }

      function close(){
        bodyEl.classList.remove('modal-open');

        _.delay(() => {
          el.removeClass('visible');
          backdrop.removeClass('visible');
        }, 350);
      }

      attrs.$observe('modalToggle', function(newVal){
        if(!helpers.isFalsey(newVal))
          open();
        else
          close();
      });

      function closeOnStateChange(event, toState){
        if(attrs.state !== toState.name)
          close(false);
      };

      var cleanup = $rootScope.$on('$stateChangeStart', closeOnStateChange);

      $scope.$on('$destroy', cleanup); // removes from $rootScope
    }
  }
}]);
